<div class="facility-details-add-container"
     *ngIf="facilityDobryAgentObject"
     [formGroup]="facilityDobryAgentForm"
     fxLayout="column"
     fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <h3>Dane placówki</h3>
        <div fxLayout="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="100">
            <mat-label>Nazwa placówki</mat-label>
            <input matInput formControlName="name">
            <mat-error *ngIf="facilityDobryAgentForm.get('name')?.hasError('backendError')">
              {{ facilityDobryAgentForm.get('name')?.getError('backendError') }}
            </mat-error>
          </mat-form-field>

          <div fxFlex="100" class="editor-field">
            <label class="editor-field__label">Opis</label>
            <angular-editor
              formControlName="description"
              [config]="editorConfig">
            </angular-editor>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <app-dict-dobry-agent-select
            fxFlex="50"
            label="Typ placówki"
            dictType="facility_type"
            formControlName="type">
          </app-dict-dobry-agent-select>

          <app-dict-dobry-agent-select
            fxFlex="50"
            label="Obsługa"
            dictType="facility_service_type"
            formControlName="serviceType">
          </app-dict-dobry-agent-select>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <mat-form-field fxFlex="50">
            <mat-label>Nr telefonu</mat-label>
            <input  appCapitalizeFirst matInput placeholder="Nr telefonu" formControlName="phoneNumber" prefix="+48" mask=" 000 000 000">
            <mat-error *ngIf="facilityDobryAgentForm.get('phoneNumber')?.hasError('required')">
              Numer telefonu jest wymagany
            </mat-error>
            <mat-error *ngIf="facilityDobryAgentForm.get('phoneNumber')?.hasError('pattern')">
              Podaj poprawny numer telefonu
            </mat-error>
            <mat-error *ngIf="facilityDobryAgentForm.get('phoneNumber')?.hasError('backendError')">
              {{ facilityDobryAgentForm.get('phoneNumber')?.getError('backendError') }}
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="50">
            <mat-label>Adres e-mail</mat-label>
            <input appCapitalizeFirst matInput placeholder="Adres mailowy"  formControlName="email">
            <mat-error *ngIf="facilityDobryAgentForm.get('email')?.hasError('required')">
              Adres e-mail jest wymagany
            </mat-error>

            <mat-error *ngIf="facilityDobryAgentForm.get('email')?.hasError('email')">
              Podaj poprawny adres email
            </mat-error>
            <mat-error *ngIf="facilityDobryAgentForm.get('email')?.hasError('backendError')">
              {{ facilityDobryAgentForm.get('email')?.getError('backendError') }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="100">
            <mat-label>Status wizytówki</mat-label>

            <mat-select formControlName="active">
              <mat-option [value]="true">
                Aktywna
              </mat-option>

              <mat-option [value]="false">
                Nieaktywna
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-card>
      <mat-card formGroupName="address">
        <h3>Adres placówki</h3>

        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <mat-form-field fxFlex="50">
            <mat-label>Ulica</mat-label>
            <input matInput formControlName="street">
            <mat-error *ngIf="facilityDobryAgentForm.get('address.street')?.hasError('backendError')">
              {{ facilityDobryAgentForm.get('address.street')?.getError('backendError') }}
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="25">
            <mat-label>Nr domu</mat-label>
            <input matInput formControlName="houseNumber">
            <mat-error *ngIf="facilityDobryAgentForm.get('address.houseNumber')?.hasError('backendError')">
              {{ facilityDobryAgentForm.get('address.houseNumber')?.getError('backendError') }}
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="25">
            <mat-label>Nr lokalu</mat-label>
            <input matInput formControlName="apartmentNumber">
            <mat-error *ngIf="facilityDobryAgentForm.get('address.apartmentNumber')?.hasError('backendError')">
              {{ facilityDobryAgentForm.get('address.apartmentNumber')?.getError('backendError') }}
            </mat-error>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <mat-form-field fxFlex="20">
            <mat-label>Kod pocztowy</mat-label>
            <input matInput placeholder="10-200" formControlName="zipCode" mask="99-999" [showMaskTyped]="true" [dropSpecialCharacters]="false">
            <mat-error *ngIf="facilityDobryAgentForm.get('address.zipCode').hasError('required')">To pole jest wymagane</mat-error>
            <mat-error *ngIf="facilityDobryAgentForm.get('address.zipCode').hasError('invalidZipCode')">Podaj prawidłowy kod pocztowy</mat-error>
            <mat-error *ngIf="facilityDobryAgentForm.get('address.zipCode')?.hasError('backendError')">
              {{ facilityDobryAgentForm.get('address.zipCode')?.getError('backendError') }}
            </mat-error>
          </mat-form-field>
          <app-city-dobry-agent-select
            fxFlex="80"
            label="Miasto"
            formControlName="city"
            (citySelected)="onCitySelected($event)">
          </app-city-dobry-agent-select>
        </div>
      </mat-card>
      <mat-card formGroupName="openHours">
        <h3>Godziny otwarcia</h3>
        <div
          *ngFor="let day of openingHoursDays"
          [formGroupName]="day.key"
          class="opening-hours-edit-row"
          fxLayout="row"
          fxLayoutGap="15px"
          fxLayoutAlign="start center"
          fxLayout.lt-md="column"
        >
          <div fxFlex="25">
            <strong>{{ day.label }}</strong>
          </div>

          <mat-checkbox
            fxFlex="15"
            formControlName="closed"
            (change)="onClosedChange(day.key)">
            Nieczynne
          </mat-checkbox>
          <mat-form-field fxFlex="20">
            <mat-label>Otwarcie</mat-label>
            <input
              matInput
              type="time"
              formControlName="openTime">
          </mat-form-field>

          <mat-form-field fxFlex="20">
            <mat-label>Zamknięcie</mat-label>
            <input
              matInput
              type="time"
              formControlName="closeTime">
          </mat-form-field>

          <button
            mat-stroked-button
            color="primary"
            type="button"
            fxFlex="10"
            matTooltip="Kopiuj ustawienia tego dnia do wszystkich dni"
            (click)="copyOpeningHoursToAllDays(day.key)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </mat-card>
      <mat-card>
        <h3>Daty nieobecności</h3>

        <div fxLayout="column" fxLayoutGap="15px">

          <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
            <app-datepicker
              fxFlex="70"
              label="Pojedynczy dzień nieobecności"
              placeholder="YYYY-MM-DD"
              [control]="dayOffDateControl">
            </app-datepicker>

            <div fxFlex="30" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                (click)="addSingleDayOff()">
                <mat-icon>add</mat-icon>
                <span>Dodaj dzień</span>
              </button>
            </div>
          </div>

          <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
            <app-datepicker
              fxFlex="35"
              label="Nieobecność od"
              placeholder="YYYY-MM-DD"
              [control]="dayOffDateFromControl">
            </app-datepicker>

            <app-datepicker
              fxFlex="35"
              label="Nieobecność do"
              placeholder="YYYY-MM-DD"
              [control]="dayOffDateToControl">
            </app-datepicker>

            <div fxFlex="30" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                (click)="addDayOffRange()">
                <mat-icon>date_range</mat-icon>
                <span>Dodaj zakres</span>
              </button>
            </div>
          </div>

          <div
            *ngIf="daysOffFromWorkArray.length > 0"
            fxLayout="row wrap"
            fxLayoutGap="8px"
            class="days-off-list">

            <mat-chip
              *ngFor="let control of daysOffFromWorkArray.controls; let i = index"
              [removable]="true"
              (removed)="removeDayOff(i)">

              {{ control.value }}

              <button matChipRemove type="button">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </div>

          <app-detail
            *ngIf="daysOffFromWorkArray.length === 0"
            header="Daty nieobecności"
            value="Brak zdefiniowanych nieobecności">
          </app-detail>
        </div>
      </mat-card>
      <mat-card>
        <h3>Wizytówka google</h3>

        <div fxLayout="column" fxLayoutGap="15px">
          <app-google-place-dobry-agent-select
            label="Wyszukaj wizytówkę Google"
            formControlName="googlePlaceId"
            (placeSelected)="onGooglePlaceSelected($event)">
          </app-google-place-dobry-agent-select>

          <mat-form-field fxFlex="100">
            <mat-label>Google Place ID</mat-label>
            <input matInput formControlName="googlePlaceId">
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>Google URL</mat-label>
            <input matInput formControlName="googleBusinessUrl">
          </mat-form-field>
        </div>
      </mat-card>
      <mat-card>
        <h3>SEO</h3>

        <div fxLayout="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="100">
            <mat-label>SEO Slug</mat-label>
            <input matInput formControlName="seoSlug">
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>SEO Title</mat-label>
            <input matInput formControlName="seoTitle">
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>SEO Description</mat-label>
            <textarea matInput formControlName="seoDescription" rows="3"></textarea>
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>SEO Keywords</mat-label>
            <textarea matInput formControlName="seoKeywords" rows="2"></textarea>
          </mat-form-field>
        </div>
      </mat-card>
    </div>
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <h3>Zdjęcia</h3>
        <app-image-drag-and-drop
          formControlName="images"
          [baseUrl]="dobryAgentBaseUrl"
          [maxSize]="3 * 1024 * 1024"
          [maxTotalSize]="8 * 1024 * 1024">
        </app-image-drag-and-drop>
        <mat-error *ngIf="facilityDobryAgentForm.get('images')?.hasError('backendError')">
          {{ facilityDobryAgentForm.get('images')?.getError('backendError') }}
        </mat-error>
      </mat-card>
      <mat-card>
        <h3>Dodatkowe</h3>
        <app-sub-category-dobry-agent-select
          label="Podkategorie"
          formControlName="subCategories">
        </app-sub-category-dobry-agent-select>
        <app-insurance-company-dobry-agent-select
          label="Towarzystwa ubezpieczeniowe"
          formControlName="insuranceCompanies">
        </app-insurance-company-dobry-agent-select>
        <app-payment-method-dobry-agent-select
          label="Metody płatności"
          formControlName="paymentMethods">
        </app-payment-method-dobry-agent-select>
        <div fxLayout="column" fxLayoutGap="15px">
          <mat-checkbox formControlName="parking">
            Parking przy placówce
          </mat-checkbox>

          <mat-checkbox formControlName="accessibilityFeatures">
            Udogodnienia dla niepełnosprawnych
          </mat-checkbox>

          <mat-checkbox formControlName="bestAgents">
            Najlepsi agenci
          </mat-checkbox>
        </div>
      </mat-card>
      <mat-card>
        <h3>Strona www</h3>

        <div fxLayout="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="100">
            <mat-label>Facebook</mat-label>
            <!--            <span matPrefix>https://&nbsp;</span>-->
            <input
              matInput
              formControlName="facebook"
              placeholder="www.facebook.com/nazwa">
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>Strona www</mat-label>
            <!--            <span matPrefix>https://&nbsp;</span>-->
            <input
              matInput
              formControlName="website"
              placeholder="www.twojastrona.pl">
          </mat-form-field>
        </div>
      </mat-card>
      <mat-card>
        <h3>Produkty Chronie.pl</h3>

        <div fxLayout="column" fxLayoutGap="15px">
          <app-affiliate-code-dobry-agent-select
            label="Kod zniżkowy Chronie.pl"
            formControlName="affiliateCode"
            [partnerFacility]="partnerFacility"
            [ofwcas]="ofwcaList">
          </app-affiliate-code-dobry-agent-select>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
</div>
